import type { FunctionComponent, ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { FreeSoloAutocompleteProps } from '../inputs/Autocomplete/FreeSoloAutocomplete';
import FreeSoloAutocomplete from '../inputs/Autocomplete/FreeSoloAutocomplete';

type FormFreeSoloSingleAutocompleteProps = Omit<
  Extract<FreeSoloAutocompleteProps, { multiple: false }>,
  'value' | 'onChange' | 'onBlur' | 'multiple'
> & {
  name: string;
};

const FormFreeSoloSingleAutocomplete: FunctionComponent<FormFreeSoloSingleAutocompleteProps> = (props) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field: { value, onChange, onBlur }, formState, fieldState }): ReactElement => {
        return (
          <FreeSoloAutocomplete
            multiple={false}
            {...props}
            onBlur={onBlur}
            value={value}
            onChange={onChange}
            disabled={!!props.disabled || formState.isSubmitting || formState.disabled}
            error={props.error ? props.error : fieldState.error?.message}
          />
        );
      }}
    />
  );
};

export default FormFreeSoloSingleAutocomplete;
